import { RefObject } from 'react';
import { IconButton } from 'src/components/Buttons/IconButton';
import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Popover } from 'src/core/ui';
import { DownRightArrowIcon } from 'src/svgs/Viagogo/functional-svgs/DownRightArrow';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './RetailTableComponents.css';
import { SalePill } from './SalePill';

export function SaleSearchPopover({
  salesGroupIds,
  onOpenSalesGroup,
  searchQuery,
  onSearchQueryChange,
  anchorRef,
}: {
  salesGroupIds: string[];
  onOpenSalesGroup: (salesGroupId: string) => void;
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  anchorRef: RefObject<HTMLDivElement | null>;
}) {
  const filteredIds = salesGroupIds.filter((id) =>
    id.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const anchorHeight = anchorRef.current?.offsetHeight ?? 0;

  return (
    <>
      <Popover.Trigger asChild>
        <div className={styles.triggerWrapper}>
          <IconButton
            icon={
              <DownRightArrowIcon
                size={vars.iconSize.xxs}
                withHoverEffect
                fill={vars.color.textBrandV2}
              />
            }
            titleContentId={ContentId.Search}
          />
        </div>
      </Popover.Trigger>
      <Popover.Content
        side="bottom"
        align="start"
        sideOffset={-anchorHeight}
        style={{ backgroundColor: vars.color.surfaceSubtle }}
      >
        <div className={styles.popoverInner}>
          <input
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            type="text"
            className={styles.searchInput}
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
          />
          <div className={styles.resultsContainer}>
            {filteredIds.length === 0 ? (
              <div className={styles.noResults}>
                <Content id={ContentId.NoResults} />
              </div>
            ) : (
              filteredIds.map((groupId) => (
                <Popover.Close asChild key={groupId}>
                  <SalePill
                    label={groupId.slice(0, 8)}
                    isGroup
                    onOpen={() => onOpenSalesGroup(groupId)}
                  />
                </Popover.Close>
              ))
            )}
          </div>
        </div>
      </Popover.Content>
    </>
  );
}
